import PublicRoomContainer from 'components/views/PublicRoom/_components/PublicRoomContainer';
import { Button, Col, Row, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import DefaultAvatar from 'components/global/DefaultAvatar';
import { $detail } from 'signals/global.signals';
import SimpleCard from 'components/global/SimpleCard';
import { ROLES } from '../../../../constants';

const PublicRoomTeam = () => {
  const navigate = useNavigate();

  return (
    <PublicRoomContainer>
      <SimpleCard>
        <Row className="mx-0 pt-xl-32 pt-lg-16">
          {$detail?.value.team?.map((user, i) => (
            <Col key={`team-Member-${i}`} lg={6} className="d-flex align-items-center mb-40">
              <Button
                className="bg-transparent border-0 p-0 me-24 me-sm-24"
                onClick={() => navigate(`/founder/${user.id}`)}
              >
                <div
                  className="d-flex justify-content-center rounded-circle imge-sm-room-team "
                  style={{ overflow: 'hidden' }}
                >
                  {user?.profileImage
                    ? <Image src={user.profileImage} className="w-100 h-100" style={{ objectFit: 'cover' }} />
                    : <DefaultAvatar name={user?.firstName} styleArr={user?.avatarColors} fontSize="2.5rem" />}
                </div>
              </Button>
              <div>
                <Button
                  // Todo: Build a better public profile so we can send people there
                  className="btn-text bg-transparent border-0 fw-600 p-0"
                  // onClick={() => navigate(`/founder/${user.id}`)}
                  disabled
                >{user.firstName} {user.lastName}
                </Button>
                <p className="mb-0">
                  {user?.roles?.length === 1 ? ROLES[user.roles[0]] : 'Multiple Roles'}
                </p>
                <p className="mb-0">{user.email}</p>
              </div>
            </Col>
          ))}
        </Row>
      </SimpleCard>
    </PublicRoomContainer>
  );
};

export default PublicRoomTeam;
